import { InterfacePageEntityComponentType } from '@unifyapps/defs/types/page';
import { PAGE_RESOURCES_STRATEGY_VS_HOOK } from '../../components/page/InterfacePageResourceLoader/constants/resourceStrategyVsHook';
import { useInterfaceResourceStrategy } from '../../context/InterfaceResourceStrategyProvider';
import { InterfaceResourceStrategies } from '../../context/InterfaceResourceStrategyProvider/constants';
import { useGlobalAppStateStore } from '../../stores/app/GlobalAppStateStore';
import { InterfaceModes, useInterfaceStore } from '../../stores/InterfaceStore';

export function useModuleResources({
  moduleId,
  moduleInterfaceRecordId,
}: {
  moduleId?: string;
  moduleInterfaceRecordId?: string;
}) {
  const interfaceStore = useInterfaceStore();
  const pageMode = interfaceStore.hooks.useMode();
  const interfaceRecordId = useInterfaceStore().hooks.record.useId();
  const locale = useGlobalAppStateStore().hooks.useLocale();
  const client = useGlobalAppStateStore().hooks.useClient();

  const moduleMode =
    pageMode === InterfaceModes.RUNNER ? InterfaceModes.RUNNER : InterfaceModes.PREVIEW;

  const { strategy } = useInterfaceResourceStrategy();

  // A module can embed a different interface than the one rendering it. When the parent is in
  // saved-version preview, its snapshot only froze its own interface tree — the foreign interface
  // was never captured at that point in time, so there is no historical state to show. Render the
  // foreign module's currently-deployed version instead; otherwise the slot would be empty.
  const isCrossInterfaceModule =
    Boolean(moduleInterfaceRecordId) && moduleInterfaceRecordId !== interfaceRecordId;
  const effectiveStrategy =
    strategy === InterfaceResourceStrategies.SavedByVersion && isCrossInterfaceModule
      ? InterfaceResourceStrategies.Deployed
      : strategy;
  const useResourceStrategy = PAGE_RESOURCES_STRATEGY_VS_HOOK[effectiveStrategy];

  return useResourceStrategy({
    interfaceId: moduleInterfaceRecordId ?? interfaceRecordId,
    interfaceComponent: {
      id: moduleId ?? '',
      type: InterfacePageEntityComponentType.MODULE,
    },
    client,
    mode: moduleMode,
    locale,
  });
}
